import React from 'react';

const FeaturedArticles = () => {
    const articles = [
        {
            title: "Run It Back: Bradford resident finds a way to re-home discarded shoes",
            source: "BradfordToday",
            date: "October 29, 2025",
            excerpt: "A Bradford resident has found an innovative way to give discarded running shoes a second life, connecting donors with those in need through the Saving Strides initiative.",
            link: "https://www.bradfordtoday.ca/helpers/run-it-back-bradford-resident-finds-a-way-to-re-home-discarded-shoes-11398628",
            image: "https://www.vmcdn.ca/f/files/bradfordtoday/2025-10-28-shettler.png;w=960",
            imageAlt: "Saving Strides shoes collection",
        },
    ];

    return (
        <div className="bg-gray-50 py-20 border-t border-gray-100">
            <section data-aos="fade-up">
                <div className="max-w-6xl mx-auto px-4 md:px-8">

                    {/* Section header */}
                    <div className="text-center mb-14">
                        <h2 className="text-3xl font-bold text-black uppercase tracking-wide mb-3">
                            Featured in the News
                        </h2>
                        <div className="flex justify-center mb-5">
                            <div className="w-16 border-b-4 border-black rounded-full"></div>
                        </div>
                        <p className="text-gray-500 text-lg max-w-xl mx-auto">
                            Read about our impact in the community
                        </p>
                    </div>

                    <div className="grid gap-6" data-aos="fade-up" data-aos-delay="200">
                        {articles.map((article, index) => (
                            <a
                                key={index}
                                href={article.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-0.5 overflow-hidden group block"
                            >
                                <div className="flex flex-col md:flex-row">
                                    {/* Image */}
                                    <div className="md:w-1/3 overflow-hidden bg-gray-100">
                                        <img
                                            src={article.image}
                                            alt={article.imageAlt}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        />
                                    </div>

                                    {/* Content */}
                                    <div className="md:w-2/3 p-6 md:p-8 flex flex-col justify-between">
                                        <div>
                                            <div className="flex items-center gap-3 mb-4">
                                                <span className="bg-black text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
                                                    Press
                                                </span>
                                                <span className="text-sm text-gray-400">{article.date}</span>
                                            </div>
                                            <h3 className="font-bold text-xl md:text-2xl mb-3 text-black group-hover:text-gray-700 transition-colors duration-200 leading-snug">
                                                {article.title}
                                            </h3>
                                            <p className="text-gray-500 text-base leading-relaxed">
                                                {article.excerpt}
                                            </p>
                                        </div>
                                        <div className="flex items-center gap-2 mt-5 text-black font-semibold group-hover:gap-3 transition-all duration-200">
                                            <span>Read full article</span>
                                            <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>

                </div>
            </section>
        </div>
    );
};

export default FeaturedArticles;
